module.exports = __webpack_public_path__ + "media/images/pokerroom/redkings/bonus-pict-423ee01cbf961c3aab055417222978f6.jpg";